import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Download, FileWarning, Loader2 } from "lucide-react";
import { WhatsAppGlyph } from "@/components/cards/CardShell";
import { contractSignLink, downloadXlsx, fetchMissingContracts } from "@/lib/bf";
import { waLink } from "@/lib/wa";

const FIRMS = [["vs", "VS"], ["fb", "Fabrica"], ["we", "W-Egan"]];
const ST = { semnat: "semnat", neconfirmat: "neconfirmat", fara_fid: "fără fidejusiune", "": "nesemnat" };

const msg = (r) => `Bună ziua, ${r.admin || ""}! Vă rog să semnați contractele cu fidejusiune pentru ${r.salon}, direct de pe telefon:\n\n${contractSignLink(r.token)}\n\nDupă semnare, confirmați din e-mailul primit. Mulțumesc!`;

export default function BFContractsMissing({ admin = false }) {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => { fetchMissingContracts().then(setRows).catch(() => setRows([])); }, []);
  const list = (rows || []).filter((r) => !q || `${r.salon} ${r.city}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <section className="invite-box bf-missing" data-testid="bf-contracts-missing">
      <h3><FileWarning size={18} /> Contracte nesemnate {rows && <span className="bf-missing-count" data-testid="bf-contracts-missing-count">{rows.length}</span>}</h3>
      <div className="share-actions"><button type="button" className="st-btn st-btn--light" onClick={() => downloadXlsx("/bf/contracts/export.xlsx", "Contracte_semnate.xlsx").catch(() => toast.error("Nu am putut descărca"))} data-testid="bf-contracts-export"><Download size={14} /> Excel cu toate contractele deja semnate</button></div>
      <p className="st-hint">Clienți{admin ? "" : "i tăi"} fără contract cu fidejusiune semnat la toate 3 firmele. Până semnează, cumpără doar cu cash sau ordin de plată, înainte de livrare.</p>
      {rows === null ? <p className="st-hint"><Loader2 size={14} className="animate-spin" /> Se încarcă…</p> : (
        <>
          {rows.length > 8 && <input className="bf-docs-title" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Caută salon sau oraș" data-testid="bf-contracts-missing-search" />}
          {!rows.length && <p className="st-hint" data-testid="bf-contracts-missing-empty">Toți clienții au contractul semnat.</p>}
          <ul className="bfa-leads">
            {list.slice(0, 300).map((r) => (
              <li key={r.id} data-testid={`bf-missing-${r.id}`}>
                <div><b>{r.salon}</b>{r.review === "de_aprobat" && <em className="bf-review-chip" data-testid={`bf-missing-review-${r.id}`}>de aprobat</em>}<span>{[r.city, admin && r.agent, r.no && `nr. ${r.no}`].filter(Boolean).join(" · ")}</span>
                  <span className="bf-missing-firms">{FIRMS.map(([k, n]) => <em key={k} className={`is-${r.firms[k] || "none"}`}>{n}: {ST[r.firms[k] || ""]}</em>)}</span></div>
                <div className="interested-actions">
                  {r.token && r.has_fid && r.phone && <a className="st-btn st-btn--ghost" href={waLink(r.phone, msg(r))} target="_blank" rel="noopener noreferrer" data-testid={`bf-missing-wa-${r.id}`}><WhatsAppGlyph /> Link</a>}
                  <Link className="st-btn st-btn--light" to={`/client/${r.id}#contract`} data-testid={`bf-missing-open-${r.id}`}>Fișa</Link>
                </div>
              </li>
            ))}
          </ul>
        </>
      )}
    </section>
  );
}
